import type { PropsWithChildren } from 'react';
import { routes } from '../../../../routes';
import { ActiveLink } from '../modules/ActiveLink';

export const HomeActiveLink = ({ children }: PropsWithChildren) => (
    <ActiveLink to={routes.HOME.path}>{children}</ActiveLink>
);
